export default "__VITE_ASSET__KCRwYxCf__"